import React from 'react';
import moment from 'moment';
import Config from '../../config/Config';
import Table from 'react-bootstrap/Table';
import Card from 'react-bootstrap/Card';
import { updateSettingsState } from '../../redux/settings/settings.actions';
import { connect } from 'react-redux';
import { htmlEncode } from '../../utils/commonFunctions';

const Certificate = ({ certificates, updateSettingsState }) => {
	var certificateslist = (
		<tr>
			<td colSpan="4">No Certificates Found</td>
		</tr>
	);
	if (typeof certificates !== 'undefined') {
		if (!!certificates && certificates.length > 0)
			certificateslist = Object.keys(certificates).map(function (certificate_key) {
				const {
					attempt_date,
					cert_id,
					cert_name,
					cert_url,
					course_name,
					linkedin_org_id,
				} = certificates[certificate_key];

				return (
					<tr key={cert_id}>
						<td data-label="Your Test Date">
							{moment(attempt_date).format('D MMM YYYY')}
						</td>
						<td data-label="Your Course">{course_name}</td>
						<td data-label="Download Certificate">
							<a
								href={cert_url}
								rel="noopener noreferrer"
								className="download-link"
								target="_blank"
							>
								<img src={Config.ASSETSPATH + 'img/downloadicon.png'} alt="" />
								Download
							</a>
						</td>
						<td data-label="Add to your profile">
							<a
								href={`https://www.linkedin.com/profile/add?startTask=CERTIFICATION_NAME&name=${htmlEncode(
									cert_name,
								)}&organizationId=${linkedin_org_id}&issueYear=${moment(
									attempt_date,
								).format('YYYY')}&issueMonth=${moment(attempt_date).format(
									'mm',
								)}&expirationYear=&expirationMonth=&certUrl=${cert_url}&certId=${cert_id}`}
								style={{ cursor: 'pointer' }}
								target="_blank"
								rel="noopener noreferrer"
							>
								<img
									src="http://download.linkedin.com/desktop/add2profile/buttons/en_US.png"
									alt="LinkedIn Add to Profile button"
								/>
							</a>
						</td>
					</tr>
				);
			});
	}
	return (
		<div>
			<div className="row">
				<div className="col-xs-12 col-md-12 col-sm-12 col-lg-12">
					<Card>
						<Card.Body>
							<Card.Title>
								<div className="page-header-left">Certificates</div>
							</Card.Title>
							<div className="table-responsive table-bordered">
								<Table className="table CertificatesTable">
									<thead>
										<tr>
											<th>Your Test Date</th>
											<th>Your Course</th>
											<th>
												<img src={Config.ASSETSPATH + 'img/certificateicon.png'} alt="" />
												Download Certificate
											</th>
											<th>Add to your profile</th>
										</tr>
									</thead>
									<tbody>{certificateslist}</tbody>
								</Table>
							</div>
						</Card.Body>
					</Card>
				</div>
			</div>
		</div>
	);
};

const mapDispatchToProps = (dispatch) => {
	return {
		updateSettingsState: (obj) => dispatch(updateSettingsState(obj)),
	};
};

const mapStateToProps = (state) => {
	const { certificates } = state.rootReducer.settingsDetails;
	return {
		certificates,
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(Certificate);
